import {EntityData, field} from "@fedelta-pos/data-client";

export class AddressData extends EntityData<AddressData> {
    @field street: string;
    @field city: string;
    @field state: string;
    @field postCode: string;
    @field country: string;

    get formattedAddress(): string {
        let address: string = "";
        if (this.street) {
            address = this.street;
        }
        if (this.city) {
            address += (address ? ", " : "") + this.city;
        }
        if (this.state && !this.postCode) {
            address += (address ? ", " : "") + this.state;
        }
        if (this.postCode) {
            address += (address ? " " : "") + this.postCode;
        }
        return address;
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/address.data.ts